/**
 * Una renovación que ya tuvo contrato (ciclo cerrado) vuelve a Legal con
 * legalStatus APPROVED. La mesa solo encola PENDING, así que hay que reabrir
 * la cola y soltar el Google Doc del ciclo anterior.
 * La misma regla vive en server/utils/renewal-legal-queue.js.
 */

const CLOSED_PIPELINE = new Set(['CLOSED', 'VERIFIED', 'BILLING']);
const ACTIVE_LATER_STAGES = new Set(['FIRMA', 'IMPLEMENTACION', 'IMPLEMENTATION', 'CIERRE']);

function priorCycleWasClosed(existing = {}) {
  const ps = String(existing.pipelineStage || '').toUpperCase();
  if (CLOSED_PIPELINE.has(ps)) return true;
  const hist = Array.isArray(existing.pipelineHistory) ? existing.pipelineHistory : [];
  return hist.some((entry) => CLOSED_PIPELINE.has(String(entry?.stage || '').toUpperCase()));
}

export function shouldReopenLegalQueue(existing = {}) {
  const legal = String(existing.legalStatus || '').toUpperCase();
  if (legal !== 'APPROVED' && legal !== 'EASYLEX_SENT') return false;
  const stage = String(existing.stage || '').toUpperCase();
  if (ACTIVE_LATER_STAGES.has(stage)) return false;
  if (!priorCycleWasClosed(existing)) return false;

  const reviewedAt = Date.parse(existing.fechaRevisionLegal || '') || 0;
  const onboardedAt = Date.parse(
    existing.onboardingCompletedAt || existing.renewalOnboardingCompletedAt || ''
  ) || 0;
  if (reviewedAt && onboardedAt && reviewedAt >= onboardedAt) return false;
  return true;
}

export function buildReopenLegalQueuePatch(existing = {}) {
  if (!shouldReopenLegalQueue(existing)) return null;
  const set = {
    legalStatus: 'PENDING',
    legalReopenedAt: new Date().toISOString(),
    legalReopenReason: 'NEW_RENEWAL_CYCLE'
  };
  const deleteKeys = [];
  const archive = (field, previousField) => {
    if (!existing[field]) return;
    set[previousField] = existing[field];
    deleteKeys.push(field);
  };
  archive('contractDocUrl', 'previousContractDocUrl');
  archive('fad_zip_url', 'previousFadZipUrl');
  archive('fechaRevisionLegal', 'previousFechaRevisionLegal');
  archive('easylexDocumentId', 'previousEasylexDocumentId');
  archive('easylexSentAt', 'previousEasylexSentAt');
  archive('easylexSignedPdfUrl', 'previousEasylexSignedPdfUrl');
  archive('easylexDocumentStatus', 'previousEasylexDocumentStatus');
  return { set, deleteKeys };
}

export function renewalContractDocUrl(renewal = {}, fallback = null) {
  if (renewal.previousContractDocUrl && !renewal.contractDocUrl) return null;
  return renewal.contractDocUrl || fallback || null;
}
